import type { InspectionPhoto, InspectionPhotoRotation } from "../../api/dto/InspectionPhoto";
/**
 * De layout van foto's is afhankelijk van de draaing van foto's. (P=portret, L=landscape) dit zijn de opties:
 *
 * P P P -> [1/3] [1/3] [1/3]
 * P L -> [1/3] [2/3]
 * L P -> [2/3] [1/3]
 * L L -> [1/2] [1/2]
 * P -> [1/3]
 * L -> [1/2]
 */

export function buildPhotoLayout(photos: InspectionPhoto[]): AbstractInspectionPhotoLayoutLine[] {
  let i = 0;
  const lines = [];
  while (i < photos.length) {
    const a = photos[i];
    const b = photos[i + 1];
    const c = photos[i + 2];
    if (a && b && c) {
      if (
        getRealRotation(a) === "portrait" &&
        getRealRotation(b) === "portrait" &&
        getRealRotation(c) === "portrait"
      ) {
        lines.push(new InspectionPhotoLayoutLinePPP(a, b, c));
        i += 3;
        continue;
      }
    }
    if (a && b) {
      if (getRealRotation(a) === "portrait" && getRealRotation(b) === "landscape") {
        lines.push(new InspectionPhotoLayoutLinePL(a, b));
        i += 2;
        continue;
      }
      if (getRealRotation(a) === "landscape" && getRealRotation(b) === "portrait") {
        lines.push(new InspectionPhotoLayoutLineLP(a, b));
        i += 2;
        continue;
      }
      if (getRealRotation(a) === "portrait" && getRealRotation(b) === "portrait") {
        lines.push(new InspectionPhotoLayoutLinePP(a, b));
        i += 2;
        continue;
      }
      if (getRealRotation(a) === "landscape" && getRealRotation(b) === "landscape") {
        lines.push(new InspectionPhotoLayoutLineLL(a, b));
        i += 2;
        continue;
      }
    }
    if (a) {
      if (getRealRotation(a) === "landscape") {
        lines.push(new InspectionPhotoLayoutLineL(a));
      } else {
        lines.push(new InspectionPhotoLayoutLineP(a));
      }
      i += 1;
      continue;
    }
    break;
  }
  return lines;
}

export function getRealRotation(photo: InspectionPhoto): InspectionPhotoRotation {
  const baseRotation = photo.baseRotation ?? "portrait";
  if (photo.rotation === 90 || photo.rotation === 270) {
    return baseRotation === "portrait" ? "landscape" : "portrait";
  }
  return baseRotation;
}

export abstract class AbstractInspectionPhotoLayoutLine {}
export class InspectionPhotoLayoutLinePPP extends AbstractInspectionPhotoLayoutLine {
  constructor(
    public readonly photoA: InspectionPhoto,
    public readonly photoB: InspectionPhoto,
    public readonly photoC: InspectionPhoto,
  ) {
    super();
  }
}
export class InspectionPhotoLayoutLinePL extends AbstractInspectionPhotoLayoutLine {
  constructor(
    public readonly photoA: InspectionPhoto,
    public readonly photoB: InspectionPhoto,
  ) {
    super();
  }
}
export class InspectionPhotoLayoutLineLP extends AbstractInspectionPhotoLayoutLine {
  constructor(
    public readonly photoA: InspectionPhoto,
    public readonly photoB: InspectionPhoto,
  ) {
    super();
  }
}
export class InspectionPhotoLayoutLineLL extends AbstractInspectionPhotoLayoutLine {
  constructor(
    public readonly photoA: InspectionPhoto,
    public readonly photoB: InspectionPhoto,
  ) {
    super();
  }
}
export class InspectionPhotoLayoutLinePP extends AbstractInspectionPhotoLayoutLine {
  constructor(
    public readonly photoA: InspectionPhoto,
    public readonly photoB: InspectionPhoto,
  ) {
    super();
  }
}
export class InspectionPhotoLayoutLineP extends AbstractInspectionPhotoLayoutLine {
  constructor(public readonly photoA: InspectionPhoto) {
    super();
  }
}
export class InspectionPhotoLayoutLineL extends AbstractInspectionPhotoLayoutLine {
  constructor(public readonly photoA: InspectionPhoto) {
    super();
  }
}
